const styles = {
  paper: {
    borderRadius: '6px',
    background: '#fff',
    padding: '22px'
  }
}

export default styles
